import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './reducer';

// If we ever do server-side rendering, the initial state needs to check
// for pre-hydrated data, probably in window.__initialState
export const initialState = {};

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        maxAge: 125
      })
    : compose;

const configureStore = (preloadedState = initialState) => {
  const store = createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(thunkMiddleware)));

  // enable HMR for reducers
  if (import.meta.env.DEV) {
    if (import.meta.hot) {
      import.meta.hot.accept('./reducer', module => {
        store.replaceReducer(module.default);
      });
    }
  }

  return store;
};

export default configureStore;
